export default __webpack_public_path__ + "static/media/Izquierdoz.5b6bb2c2.jpg";